/**
 * Soft PIN gate helpers for quote-builder pricing details.
 * Unlock is one-shot per reveal — callers must not cache success across hide/show.
 */

export function isPricingProtectionEnabled (store) {
  const profile = store && store.getters && store.getters['user/getProfile']
  if (!profile) return false
  return !!(
    profile.protect_pricing_details === true ||
    profile.protect_pricing_details === 1 ||
    profile.protect_pricing_details === '1'
  )
}
